<template>
  <div class="description__right">
    <div>
      <div
        v-if="isFormateurStatusCancel"
        class="mb-3 flex items-center justify-center space-x-2 rounded bg-jinius-red px-3 py-2 leading-none text-core-100 shadow">
        <font-awesome-icon icon="ban" />
        <span class="px-0.5"> Session annulée </span>
      </div>
      <div
        v-else-if="inscription.participantStatut && !parcours"
        class="mb-3 flex items-center justify-center space-x-2 rounded px-3 py-2 leading-none text-core-100 shadow"
        v-bind:class="
          map_statut_inscription_colors[getParticipantStatusKey]
            ? map_statut_inscription_colors[getParticipantStatusKey].color
            : map_statut_inscription_colors['isPending']
        ">
        <font-awesome-icon
          v-if="map_statut_inscription_colors[getParticipantStatusKey]"
          v-bind:icon="
            map_statut_inscription_colors[getParticipantStatusKey].icon
          "
          size="sm" />
        <span class="px-0.5">
          {{
            inscription.participantStatut.elearningParticipant
              ? map_statut_inscription_elearning_labels[
                  inscription.participantStatut.id
                ]
              : map_statut_inscription_labels[inscription.participantStatut.id]
          }}
        </span>
      </div>
    </div>

    <div>
      <div
        v-on:click="goToDetails"
        v-if="inscription.accesDetails"
        class="flex flex-grow cursor-pointer flex-wrap items-center justify-end text-base text-core-500 hover:text-core-600">
        <font-awesome-icon icon="search" />
        <span class="ml-2">Afficher les détails de la session</span>
      </div>
    </div>
    <div>
      <div
        v-if="
          inscription.catalogueReference && inscription.catalogueUrl && !produit
        "
        v-on:click="
          () =>
            goToFiche(inscription.catalogueReference, inscription.catalogueUrl)
        "
        class="mt-4 inline-flex cursor-pointer flex-wrap items-center justify-end text-base text-core-500 hover:text-core-600">
        <font-awesome-icon icon="eye" />
        <span class="ml-2.5">Voir la fiche pédagogique</span>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    map_statut_inscription_colors,
    map_statut_inscription_elearning_labels,
    map_statut_inscription_labels
  } from '@/assets/data/data_maps.js';
  import dates_helpers from '@/mixin/dates_helpers';
  import http_functions from '@/mixin/http_functions';

  export default {
    components: {},
    mixins: [dates_helpers, http_functions],
    props: {
      inscription: {
        type: Object,
        default: null
      },
      parcours: {
        type: Boolean,
        default: false
      },
      collapsed: {
        type: Boolean,
        default: null
      },
      toggle_collapse: {
        type: Function,
        default: null
      },
      espace: { type: String },
      produit: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        map_statut_inscription_colors,
        map_statut_inscription_labels,
        map_statut_inscription_elearning_labels
      };
    },
    computed: {
      isFormateurStatusCancel() {
        return this.inscription?.formateurStatut?.id === 3;
      },
      getParticipantStatusKey() {
        const key = ['isValid', 'isNotValid', 'isPending'].find(
          (key) => this.inscription.participantStatut[key] === true
        );

        return key;
      }
    },
    methods: {
      goToDetails() {
        const { reference } = this.inscription;
        if (reference) {
          this.$router.push(
            `/formateur/session-details?reference=${reference}`
          );
        }
      },

      goToFiche(reference, url) {
        if (reference && url) {
          window.open(`${url}/fiche/${reference}`);
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/css/utils/mixins' as mixin;

  .description__right {
    @apply mt-6 flex w-full flex-wrap px-4 md:w-120 md:justify-end;
    > div {
      @apply flex w-full justify-end;
    }
  }
</style>
